import React from "react";
import { useTranslation } from "react-i18next";
import Stats from "./components/Stats";
import { Col, Row } from "react-bootstrap";
import Listing from "./components/Listing";
import data from "@data/clients.json";

const Home = (props) => {
  const { t } = useTranslation();

  return (
    <section className="py-3">
      <h2
        className={`fs-3 ${
          props.profile.mode === "dark" ? "text-white" : "text-dark"
        }`}
      >
        {t("my_clients")}
      </h2>
      <Row>
        <Col xl="9" className="my-2">
          <Listing mode={props.profile.mode} t={t} data={data.clients} />
        </Col>
        <Col xl="3" className="my-2 ">
          <div className="sticky">
            <Stats mode={props.profile.mode} t={t} />
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Home;
